import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { CalendarDays } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { translations } from "@/i18n/translations";

const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_0614d46d-eee4-4b28-994f-37db8280bda0/artifacts/3ew9qzg8_Bring%20me%20cash%20-%20logo.png";
const CALENDLY_URL = "https://calendar.app.google/C866HmTsf8RckhiE9";

const NAV_ITEMS = [
  { id: "hero", key: "home" },
  { id: "offers", key: "offers" },
  { id: "events", key: "live" },
  { id: "podcast", key: "podcast" },
  { id: "footer", key: "about" },
];

export const Header = () => {
  const { lang, setLang, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md transition-all duration-300 ${
        scrolled ? "border-b border-black/10 py-3" : "py-5"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
        <img src={LOGO_URL} alt="Bring Me Cash" className="h-9 sm:h-10 w-auto" data-testid="logo-image" />

        <nav className="hidden lg:flex items-center gap-7 font-['Ubuntu'] text-sm font-medium text-black/80">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="hover:text-[#9B5DE5] transition-colors"
              data-testid={`nav-link-${item.id}`}
            >
              {translations[lang].nav[item.key]}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center border-2 border-black rounded-full overflow-hidden text-xs font-bold font-['Ubuntu']">
            <button
              onClick={() => setLang("fr")}
              data-testid="lang-switch-fr"
              className={`px-3 py-1.5 transition-colors ${lang === "fr" ? "bg-black text-white" : "bg-transparent text-black"}`}
            >
              FR
            </button>
            <button
              onClick={() => setLang("pt")}
              data-testid="lang-switch-pt"
              className={`px-3 py-1.5 transition-colors ${lang === "pt" ? "bg-black text-white" : "bg-transparent text-black"}`}
            >
              PT
            </button>
          </div>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-header-rdv"
            className="hidden sm:inline-flex items-center gap-2 bg-black text-white rounded-full px-5 py-2.5 text-sm font-bold font-['Ubuntu'] hover:bg-[#9B5DE5] transition-colors"
          >
            <CalendarDays className="w-4 h-4" /> {t.cta.schedule}
          </a>
        </div>
      </div>
    </motion.header>
  );
};
